"use client";
import { useState,useTransition } from "react";
import { FileUp } from "lucide-react";
import { toast } from "sonner";
import { uploadDocument } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Attachment,AttachmentContent,AttachmentMedia,AttachmentTitle } from "@/components/ui/attachment";
export function FileUpload() {
 const [pending,start]=useTransition(),[name,setName]=useState(""),[error,setError]=useState("");
 return <form className="space-y-4" onSubmit={event=>{event.preventDefault();const form=event.currentTarget;const data=new FormData(form);start(async()=>{try{const result=await uploadDocument(data);if(result.error){setError(result.error);return;}setError("");setName("");form.reset();toast.success("檔案已儲存");}catch{setError("上傳失敗，請再試一次");}});}}>
  <div className="space-y-2"><Label htmlFor="upload-file">選擇文件</Label><Input id="upload-file" name="file" type="file" accept=".txt,.md,.csv,.pdf" required onChange={event=>setName(event.target.files?.[0]?.name??"")}/><p className="text-sm text-muted-foreground">TXT、Markdown、CSV 或 PDF，最多 5 MB。</p></div>
  {name && <Attachment state={pending?"uploading":"idle"}><AttachmentMedia><FileUp/></AttachmentMedia><AttachmentContent><AttachmentTitle>{name}</AttachmentTitle></AttachmentContent></Attachment>}
  {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
  <Button type="submit" disabled={pending || !name}>{pending?"上傳中…":"上傳"}</Button>
 </form>;
}
